// Secrets stay outside Redux and DevTools.
const post = async (path: string, body: object): Promise<number> => {
    const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}Auth/${path}`, {
        method: 'POST', credentials: 'include', headers: {'Content-Type': 'application/json'}, body: JSON.stringify(body),
    });
    if (!response.ok) {
        let data: unknown;
        try {data = await response.json();} catch {data = undefined;}
        const retryAfter = response.headers.get('Retry-After');
        const retryAfterSeconds = retryAfter && /^\d+$/.test(retryAfter.trim()) ? Number(retryAfter) : undefined;
        throw {status: response.status, data, retryAfterSeconds};
    }
    return response.status;
};
export const confirmEmail = (userId: string, token: string) => post('ConfirmEmail', {userId, token});
export const resendConfirmationEmail = (email: string) => post('ResendConfirmationEmail', {email});
